import { Module } from 'vuex';
import { State as RootState } from './store';

export interface EvohealthState {
  healthGroups: any
}

const evohealth: Module<EvohealthState, RootState> = {
  state: {
    healthGroups: {
      biosignals: {
        id: 1,
        healthParams: {
          hearthRateId: 1,
          hearthRateVariabilityId: 2,
          systolicBloodPressureId: 3,
          diastolicBloodPressureId: 4,
          respiratoryRateId: 5,
          oxygenSaturationId: 6,
          stressIndexId: 7,
          ansIndexPnsId: 8,
          ansIndexSnsId: 9,
          activity: 10,
          health: 11,
          relaxation: 12,
          metabolism: 13,
          sleep: 14,
          equilibrium: 15,
          hrv_indices_hf: 16,
          hrv_indices_lf: 17,
          hrv_indices_lf_hf_ratio: 18,
          hrv_indices_mean_hr: 19,
          hrv_indices_phf: 20,
          hrv_indices_plf: 21,
          hrv_indices_rmssd: 22,
          hrv_indices_rriv: 23,
          hrv_indices_sd1: 24,
          hrv_indices_sd2: 25,
          hrv_indices_sdnn: 26,
          hrv_indices_sdnni: 27,
          hba1c: 33,
          hba1cRisk: 34,
          hba1cRange: 35,
          cholesterol: 36,
          cholesterolRisk: 37,
          cholesterolRange: 38,
          hemoglobin: 39
        }
      },
      biosignsQuestionnaire: {
        id: 2,
        healthParams: {
          pas: 28,
          height: 29,
          weight: 30,
          sex: 31,
          age: 32
        }
      },
      news2: {
        id: 20,
        healthParams: {
          levelOfConsciousness: 116,
          levelOfConsciousnessScore: 117,
          supplementaryOxygenAdministered: 118,
          supplementaryOxygenAdministeredScore: 119,
          temperature: 120,
          temperatureScore: 121,
          respiratoryRate: 122,
          respiratoryRateScore: 123,
          oxygenSaturation: 124,
          oxygenSaturationScore: 125,
          sbp: 126,
          sbpScore: 127,
          heartRate: 128,
          heartRateScore: 129,
          finalScoreResult: 130
        }
      }
    }

  },
};

export default evohealth;
